import React, { FC, memo } from 'react'
import styled, { StyledProps } from 'styled-components'
import { Box } from '@ucheba/ui/components/Box/desktop'
import { VideoPreview } from '@ucheba/ui/components/VideoPreview/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Description } from '@ucheba/ui/components/Description/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { IPropWidth } from '@ucheba/utils/helpers/components/prop.types'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import SC from '../base/styles'
import { ITeacherCardItem } from '../types'

const { VideoPreviewExperienceText, VideoPreviewOverlay, VideoPreviewAverageScoreText } =
  SC

const StyledBox = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 24px;
  flex: 1;
`

const TeachersListItem = styled.div<StyledProps<IPropWidth>>`
  display: flex;
  border-radius: 8px;
  overflow: hidden;
  box-shadow:
    0 25px 30px 0 rgba(3, 15, 35, 0.1),
    0 0 20px 0 ${sv.color.gray5};
`

const BottomBlock = styled.div`
  margin-top: 16px;
  flex: 1;
  display: flex;
  align-items: flex-end;
`

const TeacherCardHorizontal: FC<ITeacherCardItem> = (props) => {
  const {
    name,
    description,
    buttonText,
    onClick,
    href,
    previewImage,
    experience,
    avgScore,
    aboveNameText,
    width = '100%',
  } = props

  const VideoBlock = (
    <VideoPreview
      height='312px'
      radius='null'
      size='small'
      imgUrl={previewImage}
      Overlay={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <VideoPreviewOverlay as={Box} spacing={['small', 'large']}>
          <VideoPreviewExperienceText>
            {experience && experience.scoreText && experience.scoreText && (
              <>
                <Heading
                  as='div'
                  h3={experience.scoreText}
                  color='gold'
                  spacing='uxsmall'
                />

                <Text fontSize='small2' lineHeight='small2' color='gold'>
                  {experience.text}
                </Text>
              </>
            )}
          </VideoPreviewExperienceText>

          <VideoPreviewAverageScoreText>
            {avgScore && avgScore.scoreText && avgScore.text && (
              <>
                <Heading
                  as='div'
                  h3={avgScore.scoreText}
                  color='rose'
                  spacing='uxsmall'
                />

                <Text fontSize='small2' lineHeight='small2' color='rose'>
                  {avgScore.text}
                </Text>
              </>
            )}
          </VideoPreviewAverageScoreText>
        </VideoPreviewOverlay>
      }
    />
  )

  const VideoBlockWithoutIcon = (
    <VideoPreview
      height='312px'
      size='small'
      imgUrl={previewImage}
      radius='null'
      withIcon={false}
      Overlay={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <VideoPreviewOverlay as={Box} spacing={['small', 'large']}>
          <VideoPreviewExperienceText>
            {experience && experience.scoreText && experience.scoreText && (
              <>
                <Heading
                  as='div'
                  h3={experience.scoreText}
                  color='gold'
                  spacing='uxsmall'
                />

                <Text fontSize='small2' lineHeight='small2' color='gold'>
                  {experience.text}
                </Text>
              </>
            )}
          </VideoPreviewExperienceText>

          <VideoPreviewAverageScoreText>
            {avgScore && avgScore.scoreText && avgScore.text && (
              <>
                <Heading
                  as='div'
                  h3={avgScore.scoreText}
                  color='rose'
                  spacing='uxsmall'
                />

                <Text fontSize='small2' lineHeight='small2' color='rose'>
                  {avgScore.text}
                </Text>
              </>
            )}
          </VideoPreviewAverageScoreText>
        </VideoPreviewOverlay>
      }
    />
  )

  return (
    <TeachersListItem width={width}>
      <div
        style={{
          width: '369px',
        }}
      >
        {href ? VideoBlock : <>{VideoBlockWithoutIcon}</>}
      </div>

      <StyledBox>
        {aboveNameText && (
          <>
            {aboveNameText}

            <Spacing spacing='usmall' />
          </>
        )}

        <Heading h2={name} as='div' spacing='usmall' />

        <Description description={description} />

        {buttonText && (
          <BottomBlock>
            <Button color='orange' onClick={onClick}>
              {buttonText}
            </Button>
          </BottomBlock>
        )}
      </StyledBox>
    </TeachersListItem>
  )
}

export default memo(TeacherCardHorizontal)
